module.exports = __webpack_public_path__ + "img/J1.c6f6308e.png";